import { Component, OnInit, ElementRef, ViewChild } from '@angular/core';
import { Location } from '@angular/common';
import { DocumentSignDataService } from '../../../services/document-sign.service';
import { environment } from '../../../environments/environment';
import { Router, ActivatedRoute, NavigationEnd } from '@angular/router';
import { ErrorService } from 'services/error.service';

const HelloSign = require('hellosign-embedded');

@Component({
  selector: 'app-document-sign',
  templateUrl: './document-sign.component.html',
  styleUrls: ['./document-sign.component.css']
})
export class DocumentSignComponent implements OnInit {
  @ViewChild('documentSignContainer', { static: true }) private documentWindow: ElementRef;
  errorMessage: string;
  type: string;
  signingToken: string;
  signUrl: string;
  signatureId: string;
  loading: Boolean = true;
  client: any;
  address: string = '';
  firstname: string = '';
  isSigned: boolean = false;
  /*
    Doc Type				        TR.com sub route URL          Tripod Type
    New Lease				          /success/leasesign/            Lease
    Renewal					          /success/leaserenewal/         Renewal
    Notice to Vacate			    /success/vacaterequest/        NTV
    Lease Term Amendment      /success/leaseamendment/       LeaseTermAmendment
    Smart Home Amendment	    /success/smarthomeamendment/   SmartHomeAmendment
    Lease Transfer				    /success/leasetransfer/        TODO ~ Tripod doesn't do this ~ 12/2020
    UFC                       pop success message ~ 2/19/21  UCF
    Universal Lease Amendment /success/leaseamendment/       UniversalLeaseAmendment
    else                      pop success message ~ 2/19/21
  */
  currentDocTypesAndSubroutes = {
    "Lease": "leasesign",
    "LeaseTermAmendment": "leaseamendment",
    "SmartHomeAmendment": "smarthomeamendment",
    "NTV": "vacaterequest",
    "Renewal": "leaserenewal",
    "UniversalLeaseAmendment": "leaseamendment"
  };

  constructor(private location: Location, private activatedRoute: ActivatedRoute, private documentSignService: DocumentSignDataService, private errorService: ErrorService) {
    this.activatedRoute.queryParams.subscribe(params => {
      this.address = params["address"];
      this.firstname = params["firstname"];
    });

    const parameters = location.path().split('?')[1];

    if (parameters) {
      const params = parameters.split('&');

      const typeParam = params.find(function (x) {
        return x.indexOf('type') > -1;
      });

      if(typeParam) {
        this.type = typeParam.split('=')[1]
      }

      const signingTokenParam = params.find(function (x) {
        return x.indexOf('signingToken') > -1;
      });

      if(signingTokenParam) {
        this.signingToken = signingTokenParam.split('=')[1]
      }

      if(!this.type || !this.signingToken) {
        this.errorMessage = "Invalid Document Type or Signing Token Provided.";
      }

    } else {
      this.errorMessage = "No Signing Token or Document Type Provided.";
    }

  }

  ngOnInit() {
    const _thisThing = this;

    this.client = new HelloSign({
      clientId: environment.helloSignClientId
    });

    this.client.on('sign', (data) => {
      this.isSigned = true;
      console.log("DATA: ", data);
      const signatureId = data.signatureId;
      _thisThing.recordResidentSignature(signatureId);
    });

    this.client.on('close', () => this.isSigned ? this.redirect() : {} );

    this.getDocumentForSignature();

  }

  getDocumentForSignature = () => {
    this.documentSignService.GetDocumentForSignature(this.type, this.signingToken).subscribe((result: any) => {
      this.loading = false;

      if(result && result.SignUrl) {
        this.signUrl = result.SignUrl;

        this.client.open(this.signUrl, {
          testMode: environment.name === "Dev",
          allowCancel: false,
          container: this.documentWindow.nativeElement
        });
      }
      else if(result.ErrorMessage) {
        this.errorMessage = "Could Not Fetch Document for Signature -- " + result.ErrorMessage;
      }
      else {
        this.errorMessage = "Could Not Fetch Document For Signature";
      }
    });
  }

  recordResidentSignature = signatureId => {
    this.documentSignService.RecordResidentSignature(this.type, signatureId).subscribe((result: any) => {

    });
  }

  redirect() {
    if(this.type in this.currentDocTypesAndSubroutes) {
      window.location.href = `${environment.triconWebsiteUrl}/success/${this.currentDocTypesAndSubroutes[this.type]}?firstname=${this.firstname}&address=${this.address}}`;
    }
    else {
      this.errorService.showMessage(`Thank you`)
    }
  }

}
